<template>
  <div>
    <ul id="infinite-list" class="pr-2" v-sticky="{ zIndex: 1, stickyTop: 80,disabled: false}">
      <li v-for="day in daysList" :key="day.index">
        <slot name="day" :day="day" />
      </li>

      <div class="text-center mt-4">
        <v-btn v-if="daysList" :loading="getShipmentsIsFetching" color="#ff4a57" class="white--text" @click="loadMore">{{$t('buttons.load_more')}}</v-btn>
      </div>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { generalHelpers } from '@/_helpers'

export default {
  name: 'ShipmentsGroupByDayOverview',
  components: {},
  props: {},
  data () {
    return {}
  },
  methods: {
    ...mapActions({
      setShipmentDaysList: 'shipmentsGroupByDay/setShipmentDaysList', infinityScrollShipmentDaysList: 'shipmentsGroupByDay/infinityScrollShipmentDaysList'
    }),
    loadMore () {
      this.infinityScrollShipmentDaysList({ query: '', filters: this.getFiltersForSearchQuery, lastDay: this.getLastDay, rangeFilters: this.getRangeFiltersForSearchQuery })
    }
  },
  computed: {
    ...mapGetters({
      getShipmentDaysList: ['shipmentsGroupByDay/getShipmentDaysList'],
      getFiltersQuery: 'getFiltersQuery',
      getFiltersForSearchQuery: 'getFiltersForSearchQuery',
      getCheckedFacets: 'getCheckedFacets',
      getLastDay: ['shipmentsGroupByDay/getLastDay'],
      getRangeFiltersForSearchQuery: 'getRangeFiltersForSearchQuery',
      getShipmentsIsFetching: ['shipmentsGroupByDay/getShipmentsIsFetching'],
      getNumericValuesQuery: 'numericsFilters/getNumericValuesQuery',
      getRefinementListValuesQuery: 'refinementListFilters/getRefinementListValuesQuery',
      getRangeValuesQuery: 'rangesFilters/getRangeValuesQuery'
    }),
    daysList () {
      return this.getShipmentDaysList
    }
  },
  watch: {
    getNumericValuesQuery: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val.length > 0) {
          this.setShipmentDaysList({ query: '' })
        }
      }
    },
    getRefinementListValuesQuery: {
      immediate: true,
      deep: true,
      handler (val, oldVal) {
        if (val.length > 0 ) {
          this.setShipmentDaysList({ query: '' })
        } else if (oldVal != null) {
          if (oldVal.length > val.length) {
            this.setShipmentDaysList({ query: '' })
          }
        }
      }
    },
    getRangeValuesQuery: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        if (val.length > 0 ) {
          this.setShipmentDaysList({ query: '' })
        } else if (oldVal != null) {
          this.setShipmentDaysList({ query: '' })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}
</style>
